import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SimpleReactValidator from 'simple-react-validator';
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../../ThemeComponents/confirmAlertForDelete';
import { adminLabels } from '../../../../redux/constant/admin-label-constant';
import { Link } from "react-router-dom";
import { helperFunctions as HF } from 'helper/helperFunctions';
import { withRouter } from 'react-router-dom';
import { listActions } from '../../../../redux/actions/list-actions';
import DatePicker from "react-datepicker";
import { dataSyncActions } from '../../../../redux/actions/data-sync-actions';
import BrandsDropdownLinks from '../../Brands/BrandsDropdownLinks';
var Modal = require('react-bootstrap-modal');

//included a script link in the public/index.html to use moment like that, the reason was for comparison of dates
const moment = window.moment;
class ErrorsListing extends Component {
    constructor(props) {
        super(props);

        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        // this.dateValidator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.dateValidator = new SimpleReactValidator();
        this.state = {
            addModal: false,
            editModal: false,
            user: user,
            sorted: '',
            filtered: '',
            pageSize: 10,
            fromDate: '',
            toDate: '',
            model_id: '',
            errorsData: [],
            synced_brand_id: '',
        };
        this.callEditlist = this.callEditlist.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);

    };

    DateChangeHandler = (value, field) => {
        this.setState({ [field]: value === null ? '' : moment(value).format("YYYY-MM-DD") }, () => {
            if (this.dateValidator.allValid()) {
                const { fromDate, toDate, pageSize, } = this.state;
                this.props.getErrorsListCall(1, '', fromDate, toDate, '', '', pageSize);
            } else {
                this.dateValidator.showMessages();
                this.forceUpdate();
            }
        })
    }
    dateElement = (label, name, value, rules) => {
        var selectedDate = this.state[name] !== '' ? new Date(this.state[name]) : '';
        const { fromDate, toDate } = this.state;
        return (
            <div className='flexElem alignCenter' id={name}>
                <div className="col-md-4 no-padding">{label}:</div>
                <div className="col-md-8 no-padding">
                    <DatePicker className="form-control calender_icon" selected={selectedDate} name={name} onChange={(event) => this.DateChangeHandler(event, name)} />
                    {
                        (fromDate !== '' && toDate !== '') &&
                        this.dateValidator.message(name, value, rules)
                    }
                </div>
            </div>
        );
    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        });
    }
    callEditlist(id) {
        this.props.getListItemCall(id).then(response => {
            this.setState({
                editModal: true
            });
        });
    }

    deleteAllErrors = () => {
        const { fromDate, toDate } = this.state;
        const error_ids = this.props.errorsData.map(err => err.id);
        this.props.markSyncErrorFixedCall({ error_ids })
            .then(res => {
                if (this.state.model_id) {
                    this.props.getErrorsListCall(1, this.state.model_id, fromDate, toDate, '', '', this.state.pageSize);
                }
                else {
                    this.props.getErrorsListCall(1, '', fromDate, toDate, '', '', this.state.pageSize);
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
    //
    markAllFixed = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName='errors list' onClosePro={onClose} deleteType={this.deleteAllErrors} />
                )
            }
        })
    }

    listingPaginationData = (page, filter, sort, pageSize) => {
        // page, brand_id, from_date, to_date, filter, sort, pageSize
        const { fromDate, toDate } = this.state;
        if (this.state.user !== undefined) {
            if (this.state.user.roles[0].name === 'brand manager') {
                this.setState({ pageSize: pageSize }, function () {
                    this.props.getErrorsListCall(page, this.state.user.model_id, fromDate, toDate, filter, sort, pageSize);
                });
            }
            else {
                if (this.state.model_id) {
                    this.setState({ pageSize: pageSize }, function () {
                        this.props.getErrorsListCall(page, this.state.model_id, fromDate, toDate, filter, sort, pageSize);
                    });
                }
            }
        }
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.setState({
                synced_brand_id: this.props.location.state.brand_id
            })
        } else {
            this.setState({
                synced_brand_id: Number(this.props.match.params.brand_id)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errorsData !== this.props.errorsData) {
            this.setState({
                errorsData: this.props.errorsData
            })
        }
    }
    viewJSON = (data) => {
        this.setState({
            ...this.state,
            jsonData: data,
            addModal: true,
        })
    }

    getModelId = (id) => {
        const { fromDate, toDate } = this.state;
        this.setState({
            model_id: id,
            linkClicked: true,
        }, () => {
            this.props.getErrorsListCall(1, this.state.model_id, fromDate, toDate, '', '', 10);
        })
    }

    handleMarkFixed = (e, errorId) => {
        const { fromDate, toDate } = this.state;
        this.props.markSyncErrorFixedCall({ error_ids: [errorId] })
            .then(res => {
                if (this.state.model_id) {
                    this.props.getErrorsListCall(1, this.state.model_id, fromDate, toDate, '', '', '');
                }
                else {
                    this.props.getErrorsListCall(1, '', fromDate, toDate, '', '', '');
                }
            })
            .catch(e => {
                console.log(e);
            })
    }

    render() {
        const { filtered, toDate, fromDate } = this.state;
        const { pages, loading, } = this.props;
        const columns = [
            {
                Header: <div className='text-capitalize'>List</div>,
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: 'Sync Timestamp',
                        accessor: 'created_at',
                        className: "action-center",
                        Cell: ({ value, original }) => (
                            <div>
                                {
                                    moment(value).format('MM/DD/YYYY hh:mm:ss')
                                }
                            </div>
                        )
                    },
                    {
                        Header: 'Brand',
                        accessor: 'brand',
                        className: "action-center",
                    },
                    {
                        Header: 'Feed Type',
                        accessor: 'type',
                        className: "action-center",
                    },
                    {
                        Header: 'Status',
                        accessor: 'status',
                        className: "action-center",
                    },
                    {
                        Header: 'File Path',
                        accessor: 'file_path',
                        className: "action-center",
                        minWidth: 200,
                    },
                    {
                        Header: <div>Actions
                            <span style={{ paddingLeft: '10px', paddingTop: '5px' }}>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('brands-list') ? 'Mark All Fixed' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <button className="green iconBtn" onClick={this.markAllFixed}><IoMdCheckmarkCircle style={{ verticalAlign: 'middle' }} /></button>
                                </OverlayTrigger>
                            </span>
                        </div>,
                        accessor: "id",
                        sortable: false,
                        Cell: ({ value, original }) => (
                            <div className="flexElem alignCenter">
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('brands-list') ? 'View Details' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <Link className="viewIcon orderDetailsAction" to={{
                                        pathname: `/Admin/brand/${original.id}/BrandErrorMessages`
                                    }} />
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('brands-list') ? 'Mark Fixed' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <button className="green iconBtn" onClick={(e) => { this.handleMarkFixed(e, value) }}><IoMdCheckmarkCircle /></button>
                                </OverlayTrigger>
                            </div>
                        )
                    },
                ]
            }
        ];
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Col md={4} className="mt-md">
                                {
                                    this.dateElement('Date From', 'fromDate', fromDate !== '' && moment(fromDate, 'YYYY-MM-DD'), [{ before_or_equal: moment(this.state.toDate) }])
                                }
                            </Col>
                            <Col md={4} className="mt-md">
                                {
                                    this.dateElement('Date To', 'toDate', toDate !== '' && moment(toDate, 'YYYY-MM-DD'), [{ after_or_equal: moment(this.state.fromDate) }])
                                }
                            </Col>

                            {(this.state.user.roles[0].name === 'super admin' || this.state.user.roles[0].name === 'customer manager' || this.state.user.roles[0].name === 'zabin Staff') &&
                                <Col md={4} className="mt-md">
                                    <BrandsDropdownLinks
                                        returnModelId={this.getModelId}
                                        synced_brand_id={this.state.synced_brand_id}
                                    />
                                </Col>
                            }

                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{ textAlign: 'center', fontWeight: "500", textTransform: "capitalize" }}>Sync Errors List</h3>
                                                </Col>
                                                <Col md={12} className="mt-xlg">
                                                    <ReactTable
                                                        noDataText='No data found'
                                                        data={this.props.errorsData}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        filtered={filtered}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={this.listingPaginationData}
                                                        manual
                                                        onFetchData={(state, instance) => {
                                                            var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                            state.pageData(state.page + 1, state.filtered, sort, state.pageSize);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                        {
                                            <Modal className='custom_lg' show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader' className="headerTitle">Error Messages</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {
                                                                this.state.jsonData !== undefined &&
                                                                this.state.jsonData.map(message => {
                                                                    return <div>{message.message}</div>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        }
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getErrorsListCall: (page, brand_id, from_date, to_date, filter, sort, pageSize) => { dispatch(dataSyncActions.getErrorsList(page, brand_id, from_date, to_date, filter, sort, pageSize)) },
        markSyncErrorFixedCall: (error_ids) => { return dispatch(dataSyncActions.markSyncErrorFixed(error_ids)) },
        getListItemCall: (id) => { return dispatch(listActions.getListItem(id)) },
        storeListCall: (listData) => { return dispatch(listActions.storeList(listData)) },
        editListCall: (listData, id) => { return dispatch(listActions.editList(listData, id)) },
        deleteListCall: (id) => { return dispatch(listActions.deleteList(id)) },
    });
};

function mapStateToProps(state, ownProps) {

    // const data = [`${[ownProps.name]}`];
    const { errorsData, loading, pages, current_page,
    } = state.dataSyncReducer;

    return {
        parentData: state.listReducer[ownProps.parent],
        loading, pages, current_page,
        errorsData,
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorsListing));



// WEBPACK FOOTER //
// ./src/components/Admin/DataSync/SyncError/ErrorsListing.jsx